import React, { useState, useEffect } from "react";
import axios from "axios";
import ResourceProp from "./ResourceProp";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL ||
  process.env.REACT_APP_API_URL 

const Resources = () => {
  const [landData, setLandData] = useState([]);
  const [financeData, setFinanceData] = useState([]);
  const [toolsData, setToolsData] = useState([]);
  const [phoneData, setPhoneData] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/resources`)
      .then((response) => {
        const res = response.data;
        if (res.success) {
          setLandData(
            (res.landAccess || []).map((item) => ({
              label: item.label,
              value: `${item.count.toLocaleString()} (${item.percent}%)`,
              percent: item.percent,
            }))
          );
          setFinanceData(
            (res.financeAccess || []).map((item) => ({
              label: item.label,
              value: `${item.count.toLocaleString()} (${item.percent}%)`,
              percent: item.percent,
            }))
          );
          setToolsData(
            (res.toolsTechnology || []).map((item) => ({
              label: item.label,
              value: `${item.count.toLocaleString()} (${item.percent}%)`,
              percent: item.percent,
            }))
          );
          setPhoneData(
            (res.mobilephone || []).map((item) => ({
              label: item.label,
              value: `${item.count.toLocaleString()} (${item.percent}%)`,
              percent: item.percent,
            }))
          );
        }
      })
      .catch((error) => console.error("Error fetching resources:", error));
  }, []);

  return (
    <div className="p-10 grid grid-cols-1 md:grid-cols-2 gap-8">
      <ResourceProp title="Land Access" data={landData} />
      <ResourceProp title="Finance Access" data={financeData} />
      <ResourceProp title="Tools & Technology" data={toolsData} />
      <ResourceProp title="Phone Access" data={phoneData} />
    </div>
  );
};

export default Resources;
